import { render, staticRenderFns } from "./CreateKlaimCCPp.vue?vue&type=template&id=87263fde&scoped=true&"
import script from "./CreateKlaimCCPp.vue?vue&type=script&lang=js&"
export * from "./CreateKlaimCCPp.vue?vue&type=script&lang=js&"
import style0 from "./CreateKlaimCCPp.vue?vue&type=style&index=0&id=87263fde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87263fde",
  null
  
)

export default component.exports